import { AlertService } from 'src/app/shared/toast/alert.service';
import { PreventRouteSwitchingGaurdService } from './../../services/prevent-route-switching-gaurd.service';
import { TranslateService } from '@ngx-translate/core';
import { ManagePracticeService } from './../manage-practice.service';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';

@Component({
  selector: 'app-practice-information',
  templateUrl: './practice-information.component.html',
  styleUrls: ['./practice-information.component.css']
})
export class PracticeInformationComponent implements OnInit {
  form: FormGroup
  insurances: any = [];
  race: any = [];
  attributeCategories: any = [];
  counselor: any = []
  error: any
  selection: any = []
  selectionRace:any=[]
  languages: any = []
  title: any = "PracticeInformation"
  selectedLanguage: any = []
  selectedRace:any=[]
  constructor(

    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private managePracticeService: ManagePracticeService,
    private loadingService: CustomLoadingService,
    private router: Router,
    private alertService:AlertService
  ) {

    this.form = this.formBuilder.group({

      Notes: [''],
      Insurances: new FormArray([]),
      Languages: [this.languages],
      Race: [this.race],
      "Male": [false],
      "Female": [false],
      "Days": [false],
      "Evenings": [false],
      "Weekends": [false],
      "Adults": [false],
      "ADDADHD": [false],
      "AddictionsNonChemical": [false],
      "AdolescentsAge1217": [false],
      "AngerManagement": [false],
      "AnxietyDepression": [false],
      "Autism": [false],
      "Bipolar": [false],
      "CareerPlanningCounseling": [false],
      "ChildrenUnderAge12": [false],
      "CognitiveBehavioralTherapy": [false],
      "ChristianCounseling": [false],
      "DomesticViolencePerpetrator": [false],
      "DomesticViolenceVictim": [false],
      "EatingDisorders": [false],
      "EldercareIssues": [false],
      "EMDR": [false],
      "FitnessForDuty": [false],
      "LGBTQ": [false],
      "Military": [false],
      "OccupatinalChallenges": [false],
      "PhysicalSexualAbuse": [false],
      "PostPartumDepression": [false],
      "Prenatal": [false],
      "SubstanceAbuse": [false],
      "TraumaGriefLoss": [false],
      

    });
  }

  ngOnInit(): void {

    this.activatedRoute.data.subscribe((data: { practiceInformation: any }) => {

      if (data.practiceInformation) {


        this.insurances = data.practiceInformation.InsuranceList;
        this.attributeCategories = data.practiceInformation.Attributes;
        this.languages = data.practiceInformation.Languages;
        this.race = data.practiceInformation.Race;

        this.form.controls["Male"].setValue(this.attributeCategories.Male)
        this.form.controls["Female"].setValue(this.attributeCategories.Female)
        this.form.controls["Days"].setValue(this.attributeCategories.Days)
        this.form.controls["Evenings"].setValue(this.attributeCategories.Evenings)
        this.form.controls["Weekends"].setValue(this.attributeCategories.Weekends)
        this.form.controls["Adults"].setValue(this.attributeCategories.Adults)
        this.form.controls["ADDADHD"].setValue(this.attributeCategories.ADDADHD)
        this.form.controls["AddictionsNonChemical"].setValue(this.attributeCategories.AddictionsNonChemical)
        this.form.controls["AdolescentsAge1217"].setValue(this.attributeCategories.AdolescentsAge1217)
        this.form.controls["AngerManagement"].setValue(this.attributeCategories.AngerManagement)
        this.form.controls["AnxietyDepression"].setValue(this.attributeCategories.AnxietyDepression)
        this.form.controls["Autism"].setValue(this.attributeCategories.Autism)
        this.form.controls["Bipolar"].setValue(this.attributeCategories.Bipolar)
        this.form.controls["CareerPlanningCounseling"].setValue(this.attributeCategories.CareerPlanningCounseling)
        this.form.controls["ChildrenUnderAge12"].setValue(this.attributeCategories.ChildrenUnderAge12)
        this.form.controls["CognitiveBehavioralTherapy"].setValue(this.attributeCategories.CognitiveBehavioralTherapy)
        this.form.controls["ChristianCounseling"].setValue(this.attributeCategories.ChristianCounseling)
        this.form.controls["DomesticViolencePerpetrator"].setValue(this.attributeCategories.DomesticViolencePerpetrator)
        this.form.controls["DomesticViolenceVictim"].setValue(this.attributeCategories.DomesticViolenceVictim)
        this.form.controls["EatingDisorders"].setValue(this.attributeCategories.EatingDisorders)
        this.form.controls["EldercareIssues"].setValue(this.attributeCategories.EldercareIssues)
        this.form.controls["EMDR"].setValue(this.attributeCategories.EMDR)
        this.form.controls["FitnessForDuty"].setValue(this.attributeCategories.FitnessForDuty)
        this.form.controls["LGBTQ"].setValue(this.attributeCategories.LGBTQ)
        this.form.controls["Military"].setValue(this.attributeCategories.Military)
        this.form.controls["OccupatinalChallenges"].setValue(this.attributeCategories.OccupatinalChallenges)
        this.form.controls["PhysicalSexualAbuse"].setValue(this.attributeCategories.PhysicalSexualAbuse)
        this.form.controls["PostPartumDepression"].setValue(this.attributeCategories.PostPartumDepression)
        this.form.controls["Prenatal"].setValue(this.attributeCategories.Prenatal)
        this.form.controls["SubstanceAbuse"].setValue(this.attributeCategories.SubstanceAbuse)
        this.form.controls["TraumaGriefLoss"].setValue(this.attributeCategories.TraumaGriefLoss)
     //     this.form.controls["Race"].setValue(this.attributeCategories.Race.split(","))
          this.form.controls["Race"].setValue(this.attributeCategories.Race.split(",").map(Number));
      this.selectionRace=this.attributeCategories.Race.split(",").map(Number)
        this.form.controls["Notes"].setValue(this.attributeCategories.Notes)
        this.bindLanguage();
        this.bindInsurances();
        this.bindRace();
      }

    });
  }
  bindInsurances() {
    const formArray: FormArray = this.form.get('Insurances') as FormArray;

    this.insurances.forEach(element => {
      /* Selected */
      if (element.IsSelected) {
        // Add a new control in the arrayForm
        formArray.push(new FormControl(element.Id));
      }

    });

  }

  bindRace() {

    const formArray: FormArray = this.form.get('Languages') as FormArray;

    this.race.forEach(element => {
      /* Selected */
    
      if (this.selectionRace.indexOf( element.Id)>-1) {
        // Add a new control in the 
        this.selectedRace.push(element);
        
        element.IsSelected=true;
      }

    });
   
  
  }

  bindLanguage() {

    // const formArray: FormArray = this.form.get('Languages') as FormArray;

    this.languages.forEach(element => {
      /* Selected */
      if (element.IsSelected) {
        // Add a new control in the 
        this.selection.push(element.Id);
        this.selectedLanguage.push(element);
      }

    });

  }

  onRaceChange(event) {

    // const formArray: FormArray = this.form.get('Languages') as FormArray;
    this.selectedRace=[];
    this.race.forEach(l => {
      if (event.indexOf(l.Id) > -1) {
        this.selectedRace.push(l);
        l.IsSelected = true;
      }
      else {
        l.IsSelected = false;
      }
    });


  }

  onLangChange(event) {
    this.selectedLanguage=[];
    this.languages.forEach(l => {
      if (event.indexOf(l.Id) > -1) {
        this.selectedLanguage.push(l);
        l.IsSelected = true;
      }
      else {
        l.IsSelected = false;
      }
    });
    
   
  }
removeLang(id){
  var index = this.selection.indexOf(id);
  this.selection.splice(index, 1);
  this.form.controls["Languages"].setValue(this.selection)
  this.onLangChange(this.selection);

 
  console.log(this.selection)
}
removeRace(id){
  var index = this.selectionRace.indexOf(id);
  this.selectionRace.splice(index, 1);
  this.form.controls["Race"].setValue(this.selectionRace)
  this.onRaceChange(this.selectionRace);
}
  onCheckChange(event) {
    const formArray: FormArray = this.form.get('Insurances') as FormArray;

    /* Selected */
    if (event.target.checked) {
      // Add a new control in the arrayForm
      formArray.push(new FormControl(event.target.value));
    }
    /* unselected */
    else {
      // find the unselected element
      let i: number = 0;

      formArray.controls.forEach((ctrl: FormControl) => {
        if (ctrl.value == event.target.value) {
          // Remove the unselected element from the arrayForm
          formArray.removeAt(i);
          return;
        }

        i++;
      });
    }
  }
  add(model: any) {
   


    if (this.form.valid) {
      this.loadingService.show();
      this.managePracticeService.addPracticeInformation(model).subscribe(res => {
        this.alertService.success(this.translateService.instant("RecordSaved"), { keepAfterRouteChange: true })
        this.router.navigate(["/managepractice"]);

      }, (error) => {
        this.alertService.error(this.translateService.instant("GenericError"), { keepAfterRouteChange: true })
       
        this.loadingService.hide();
      }, () => {
        this.loadingService.hide();
      })
    }
  }

}
